import {useState} from "react";
import { Tabs as BsTabs} from "react-bootstrap";
import {useNavigate} from "react-router";
import {TabsProps} from "react-bootstrap/Tabs";


/**
 * Wrapper around the Bootstrap Tabs component
 */
export default function Tabs({ urlFormatter, onSelect, children, ...props}: TabsProps & {
  urlFormatter: (k: string) => string;
  onSelect?: (k: string) => void;
  defaultActiveKey?: string;
}) {
    const [key, setKey] = useState<string | undefined>(props.defaultActiveKey);
    const navigate = useNavigate();
    return (
        <BsTabs
            {...props}
            activeKey={key}
            onSelect={(k) => {
              if (k) {
                setKey(k);
                navigate(urlFormatter(k));
                if (onSelect) onSelect(k);
              }
            }}
        >
            {children}
        </BsTabs>
    )
}
